export default __webpack_public_path__ + "static/decent-work-68cc8849677264f4db984e37660f78dc.png";